import React from "react";
import Slider from "@material-ui/core/Slider";
import { withStyles } from "@material-ui/core/styles";
import { l } from "../functions";
import Icon from "./Icons";
import PropTypes from "prop-types";

const MySlider = withStyles({
  valueLabel: {
    "& *": {
      background: "#FFF",
      color: "#000",
    },
  },
})(Slider);

export default class SizeSetter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value,
      textValue: this.props.value,
      error: false,
      dropDown: false,
    };
  }

  componentWillReceiveProps({ value }) {
    if (value !== this.props.value && value !== this.state.value)
      this.setState({ value: value, textValue: value });
  }

  _changeValue = (val) => {
    const { min, max, onChange } = this.props;
    const format = /[1234567890]/;

    this.setState(
      {
        textValue: val,
      },
      () => {
        if (format.test(val) && parseInt(val) >= min && parseInt(val) <= max) {
          this.setState(
            {
              value: parseInt(val),
              error: false,
            },
            () => {
              onChange(parseInt(val));
            }
          );
        } else {
          this.setState({ error: true });
        }
      }
    );
  };

  render() {
    const { value } = this.state;

    return (
      <div
        className={`gk-form-row-container slider-range slider-range-theme ${
          !Array.isArray(value) ? "mright" : ""
        }`}
      >
        <span className="title">{this.props.title}</span>
        {!Array.isArray(value) && (
          <div className="tooltip-container">
            {this.state.error && (
              <span className="my-tooltip top-left">{l("Invalid!")}</span>
            )}
            <input
              type="text"
              value={this.state.textValue}
              onChange={(event) => {
                const val = event.target.value;
                this._changeValue(val);
              }}
            />
            <button
              onClick={() => this.setState({ dropDown: !this.state.dropDown })}
            >
              <Icon icon="dropdown" />
            </button>
          </div>
        )}
        {this.state.dropDown && (
          <div className="size-dropdown">
            <ul>
              {this.props.semiBody && (
                <>
                  <li
                    onClick={() => {
                      this._changeValue(12);
                      this.setState({ dropDown: !this.state.dropDown });
                    }}
                    className={value == 12 ? "active" : ""}
                  >
                    12 px
                  </li>
                  <li
                    onClick={() => {
                      this._changeValue(14);
                      this.setState({ dropDown: !this.state.dropDown });
                    }}
                    className={value == 14 ? "active" : ""}
                  >
                    14 px
                  </li>
                </>
              )}
              <li
                onClick={() => {
                  this._changeValue(16);
                  this.setState({ dropDown: !this.state.dropDown });
                }}
                className={value == 16 ? "active" : ""}
              >
                16 px
              </li>
              <li
                onClick={() => {
                  this._changeValue(20);
                  this.setState({ dropDown: !this.state.dropDown });
                }}
                className={value == 20 ? "active" : ""}
              >
                20 px
              </li>
              <li
                onClick={() => {
                  this._changeValue(24);
                  this.setState({ dropDown: !this.state.dropDown });
                }}
                className={value == 24 ? "active" : ""}
              >
                24 px
              </li>
              {!this.props.semiBody && (
                <>
                  <li
                    onClick={() => {
                      this._changeValue(28);
                      this.setState({ dropDown: !this.state.dropDown });
                    }}
                    className={value == 28 ? "active" : ""}
                  >
                    28 px
                  </li>
                  <li
                    onClick={() => {
                      this._changeValue(32);
                      this.setState({ dropDown: !this.state.dropDown });
                    }}
                    className={value == 32 ? "active" : ""}
                  >
                    32 px
                  </li>
                </>
              )}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

SizeSetter.defaultProps = {
  min: 0,
  max: 64,
  onChange: () => {},
  title: "Size",
  value: 16,
};
